import { style } from "@vanilla-extract/css";
import { vars } from "../../styles";

export const listWrapper = style({
  display: "flex",
  padding: vars.space.xs,
});
